<template>
  <article class="layout-section">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Alert Component</h2>
      <p class="type-code">ActionAlert.vue</p>
    </div>

    <ActionAlert label="Alert Default (color is defined with the accent color of the style guide)" />
    <ActionAlert label="Alert Warning" class="-warning" />
    <ActionAlert label="Alert Critical" class="-critical" />
  </article>
</template>

<script>
export default {
  name: 'DemoAlert'
}
</script>
